import { StatsCard, ChartCard } from "@/components/index";
import API from "../services/api-request.js";
import Chartist from "chartist";
import { VueCookieNext } from "vue-cookie";
export default {
  components: {
    StatsCard,
    ChartCard,
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data() {
    return {
      statsCards: [
        {
          type: "info",
          icon: "fa fa-building",
          title: "Sites",
          value: "0",
        },
        {
          type: "success",
          icon: "fa fa-hotel",
          title: "Hotels",
          value: "0",
        },
        {
          type: "danger",
          icon: "fa fa-cutlery",
          title: "Restaurants",
          value: "0",
        },
        {
          type: "warning",
          icon: "fa fa-car",
          title: "Voitures",
          value: "0",
        },
        {
          type: "info",
          icon: "fa fa-user",
          title: "Partenaires",
          value: "0",
        },
        {
          type: "success",
          icon: "fa fa-user",
          title: "Utilisateurs",
          value: "0",
        },
        {
          type: "danger",
          icon: "ti-view-grid",
          title: "Reservations",
          value: "0",
        },
        {
          type: "warning",
          icon: "fa fa-truck",
          title: "News",
          value: "0",
        },
      ],
    };
  },
  methods: {
    getDashInfo() {
      API.index("admin-dashboard").then((response) => {
        this.statsCards[0].value = response.data.tour;
        this.statsCards[1].value = response.data.hotel;
        this.statsCards[2].value = response.data.resto;
        this.statsCards[3].value = response.data.car;
        this.statsCards[4].value = response.data.partner;
        this.statsCards[5].value = response.data.customer;
        this.statsCards[6].value = response.data.booking;
        this.statsCards[7].value = response.data.news;
      });
    },
  },
  mounted() {
    this.getDashInfo();
  },
};
